import TextEllipsis from './index.vue';

export default TextEllipsis;
